import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SessionProvider } from './context/SessionContext';
import { ThemeProvider } from './theme/ThemeProvider';
import { ErrorBoundary } from './ErrorBoundary';
import './index.css';
import '../../../packages/ozira-shell-kit/src/shellKit.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
